module.exports = __webpack_public_path__ + "img/login-owner.61238b1b.jpg";